export default __webpack_public_path__ + "static/linkBg3_shadow-5a5e7e1af707b994311185366c1de713.png";